var _defs, _circle, _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmiley100Percent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#67b419;}.cls-2{fill:#24b419;}.cls-3{fill:#515151;}.cls-4{fill:none;stroke:#515151;stroke-miterlimit:10;stroke-width:15px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200.5,
    cy: 199.5,
    r: 192.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.5,12a187.55,187.55,0,0,1,73,360.27,187.55,187.55,0,0,1-146-345.54A186.38,186.38,0,0,1,200.5,12m0-10C91.42,2,3,90.42,3,199.5S91.42,397,200.5,397,398,308.58,398,199.5,309.58,2,200.5,2Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 115.14,
    cy: 162.99,
    rx: 33.58,
    ry: 37.03,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -48.02, 48.09)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 278.14,
    cy: 162.99,
    rx: 37.03,
    ry: 33.57,
    transform: "translate(31.26 370.3) rotate(-70.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.3,251.28s100.51,101.93,202.44,0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley100Percent);
export default __webpack_public_path__ + "static/media/smiley-100-percent.752c9f0a660d9ad94ba7f86ae4de9079.svg";
export { ForwardRef as ReactComponent };